import { requestAndParse, requestSuccessful } from '../request';

const addQuestionToStudy = async (studyId: number, questionId: number) => {
    const route = 'admin/add-question-to-study';
    const payload = { studyId, questionId };

    const response = await requestAndParse(route, payload, 'POST');

    const success = requestSuccessful(response);

    return success;
};

export default addQuestionToStudy;
